"use client";

import { c as _c } from "react/compiler-runtime";
interface Props {
  message?: string;
}
export function CartItemError(t0) {
  const $ = _c(2);
  const {
    message
  } = t0;
  if (!message) {
    return null;
  }
  let t1;
  if ($[0] !== message) {
    t1 = <p role="alert" className="px-5 text-sm text-destructive">{message}</p>;
    $[0] = message;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}